import React from "react";
import { Box, Typography } from "@mui/material";
import { Slider } from "@mui/material";

function ReadOnlySlider({ label, value, selection }) {
  const color =
    selection === "Backward"
      ? "#ff8787"
      : selection === "Forward"
      ? "#1976d2"
      : "#127812";
  const sliderStyle = {
    "& .MuiSlider-root": {
      color: `${color} !important`,
    },
    "& .MuiSlider-rail": {
      opacity: 0.5,
      backgroundColor:
        selection === "Backward" ? "#ffe3e3 !important" : "#e3f2fd !important",
    },
    "& .MuiSlider-track": {
      border: "none",
      backgroundColor: `${color} !important`,
      opacity: "1 !important",
    },
    "& .MuiSlider-thumb": {
      height: 18,
      width: 18,
      backgroundColor: "#fff !important",
      border: `2px solid ${color} !important`,
      opacity: "1 !important",
      "&.Mui-disabled": {
        height: "18px !important",
        width: "18px !important",
        backgroundColor: "#fff !important",
        border: `2px solid ${color} !important`,
      },
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&:before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      lineHeight: 1.2,
      fontSize: 12,
      background: "unset",
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: `${color} !important`,
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&:before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },
    // disabled 상태 완전 덮어쓰기
    "&.Mui-disabled": {
      color: `${color} !important`,
      "& .MuiSlider-track": {
        backgroundColor: `${color} !important`,
        opacity: "1 !important",
      },
      "& .MuiSlider-thumb": {
        backgroundColor: "#fff !important",
        border: `2px solid ${color} !important`,
      },
    },
  };
  return (
    <Box sx={{ width: "100%", mb: 2, minWidth: "300px" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body2" sx={{ color: color, fontWeight: 500 }}>
          {label}
        </Typography>
        <Typography variant="body2" sx={{ color: color, fontWeight: 500 }}>
          {value}
        </Typography>
      </Box>
      <Slider
        value={value || 1}
        min={1}
        max={10}
        disabled
        sx={sliderStyle}
        valueLabelDisplay="auto"
      />
    </Box>
  );
}

export default ReadOnlySlider;
